import { render } from "./modal-form-approval.vue?vue&type=template&id=48c22c74&scoped=true&ts=true"
import script from "./modal-form-approval.vue?vue&type=script&lang=ts"
export * from "./modal-form-approval.vue?vue&type=script&lang=ts"

import "./modal-form-approval.vue?vue&type=style&index=0&id=48c22c74&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c22c74"]])

export default __exports__